<template>
  <div
    class="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-lg z-50"
  >
    <!-- Loading indikátor s tlačítkem Stop -->
    <Transition name="slide">
      <div
        v-if="isLoading"
        class="absolute -top-12 left-1/2 -translate-x-1/2 bg-white rounded-full shadow-lg px-4 py-2 flex items-center gap-3"
      >
        <div class="flex gap-1">
          <span class="w-2 h-2 bg-red-600 rounded-full animate-bounce"></span>
          <span
            class="w-2 h-2 bg-red-600 rounded-full animate-bounce"
            style="animation-delay: 0.1s"
          ></span>
          <span
            class="w-2 h-2 bg-red-600 rounded-full animate-bounce"
            style="animation-delay: 0.2s"
          ></span>
        </div>
        <span class="text-sm text-gray-600">Rich odpovídá...</span>
        <button
          @click="$emit('cancel')"
          class="ml-2 px-3 py-1 text-xs bg-red-100 hover:bg-red-200 text-red-700 rounded-full transition-colors flex items-center gap-1"
          title="Zastavit generování"
        >
          <svg class="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
          </svg>
          Stop
        </button>
      </div>
    </Transition>

    <!-- Suggestions - Skryto do odvolání -->
    <!-- <div class="px-4 py-2 border-b border-gray-100">
      <div class="flex gap-2 overflow-x-auto scrollbar-hide">
        <span class="text-gray-700 font-medium flex items-center gap-2">
          <span class="hidden sm:inline">💡 Co můžeme udělat dále:</span>
          <span class="sm:hidden">💡</span>
        </span>
        <button
          class="whitespace-nowrap px-3 py-1.5 text-sm bg-gradient-to-r from-red-50 to-orange-50 hover:from-red-100 hover:to-orange-100 rounded-full border border-red-200 transition-colors flex items-center gap-1.5"
          @click="$emit('openRVSAnalyzer')"
          :disabled="isLoading"
          :class="{ 'opacity-50 cursor-not-allowed': isLoading }"
          title="Analyzovat logy z tepelných čerpadel RVS"
        >
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
          </svg>
          <span class="hidden sm:inline">📊 Analýza RVS logů</span>
          <span class="sm:hidden">📊 RVS</span>
        </button>
        <button
          v-for="suggestion in suggestions.slice(1)"
          :key="suggestion"
          @click="handleSuggestion(suggestion)"
          :disabled="isLoading"
          :class="[
            'whitespace-nowrap px-3 py-1.5 text-sm bg-gray-50 hover:bg-gray-100 rounded-full border border-gray-200 transition-colors',
            { 'opacity-50 cursor-not-allowed': isLoading },
          ]"
        >
          {{ suggestion }}
        </button>
      </div>
    </div> -->

    <!-- Preview nahraných souborů -->
    <Transition name="slide">
      <div v-if="pendingFiles.length > 0" class="px-4 pt-3 pb-1">
        <div class="flex flex-wrap gap-2">
          <div
            v-for="(file, index) in pendingFiles"
            :key="index"
            class="flex items-center gap-2 px-3 py-1.5 bg-gray-100 rounded-lg text-sm"
          >
            <span v-if="file.uploading" class="w-4 h-4">
              <svg class="animate-spin w-4 h-4 text-red-600" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" fill="none"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
              </svg>
            </span>
            <span v-else-if="file.uploaded" class="text-green-600">
              <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
              </svg>
            </span>
            <span v-else class="text-gray-500">{{ getFileIcon(file.type) }}</span>
            <span class="truncate max-w-[150px]">{{ file.name }}</span>
            <span class="text-gray-400 text-xs">({{ formatFileSize(file.size) }})</span>
            <button
              @click="removeFile(index)"
              class="text-gray-400 hover:text-red-600 transition-colors"
              :disabled="file.uploading"
            >
              <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </Transition>

    <!-- Kompaktní input -->
    <div class="p-3 pt-2" v-if="!isExpanded">
      <!-- Horní řádek: délka odpovědi -->
      <div class="flex items-center gap-1 mb-2 px-1">
        <button
          v-for="opt in responseOptions"
          :key="opt.value"
          :disabled="isLoading"
          :class="[
            'px-2 py-0.5 text-xs rounded border transition-all duration-200',
            props.responseLength === opt.value
              ? 'bg-red-600 text-white border-red-600'
              : 'bg-white text-gray-500 border-gray-200 hover:border-gray-300',
            { 'opacity-50 cursor-not-allowed': isLoading },
          ]"
          @click="$emit('setResponseLength', opt.value)"
          :title="opt.title"
        >
          {{ opt.shortLabel }}
        </button>
      </div>

      <!-- Spodní řádek: sponka + input + odeslat -->
      <div class="flex gap-2 items-center">
        <!-- Tlačítko pro přílohy -->
        <button
          @click="triggerFileInput"
          :disabled="isLoading || isUploading"
          class="p-2 text-gray-500 hover:text-red-600 hover:bg-gray-100 rounded-full transition-all flex-shrink-0"
          :class="{ 'opacity-50 cursor-not-allowed': isLoading || isUploading }"
          title="Přiložit soubory (PDF, obrázky, dokumenty...)"
        >
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13" />
          </svg>
        </button>
        <input
          ref="fileInput"
          type="file"
          multiple
          accept=".pdf,.doc,.docx,.xls,.xlsx,.csv,.md,.txt,.jpg,.jpeg,.png,.gif,.webp,.zip"
          class="hidden"
          @change="handleFileSelect"
        />

        <!-- Input pole s expand tlačítkem -->
        <div class="relative flex-1 min-w-0">
          <input
            v-model="localValue"
            @keydown.enter.prevent="submit"
            @focus="handleInputFocus"
            @dragover.prevent="isDragging = true"
            @dragleave="isDragging = false"
            @drop.prevent="handleDrop"
            ref="compactInput"
            class="w-full px-4 py-2.5 pr-10 rounded-full border-2 transition-colors text-sm"
            :class="[
              isDragging ? 'border-red-500 bg-red-50' : 'border-gray-200 focus:border-red-500',
              { 'opacity-50 cursor-not-allowed': isLoading }
            ]"
            :placeholder="
              isDragging
                ? 'Pusťte soubory zde...'
                : isLoading
                ? 'Počkejte...'
                : 'Napište otázku...'
            "
            :disabled="disabled || isLoading"
          />
          <!-- Expand tlačítko -->
          <button
            @click="expandInput"
            :disabled="isLoading"
            class="absolute right-1 top-1/2 -translate-y-1/2 p-1.5 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-full transition-all"
            :class="{ 'opacity-50 cursor-not-allowed': isLoading }"
            title="Rozbalit pro delší text"
          >
            <svg
              class="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4"
              />
            </svg>
          </button>
        </div>

        <!-- Tlačítko odeslat -->
        <button
          @click="submit"
          :disabled="(!(localValue || '').trim() && pendingFiles.filter(f => f.uploaded).length === 0) || disabled || isLoading || isUploading"
          class="px-4 py-3 bg-red-600 text-white rounded-full hover:bg-red-700 disabled:opacity-50 disabled:cursor-not-allowed transition-all"
        >
          <!-- Loading spinner nebo normální ikona -->
          <svg
            v-if="isLoading || isUploading"
            class="animate-spin h-5 w-5"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              class="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              stroke-width="4"
            ></circle>
            <path
              class="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            ></path>
          </svg>
          <svg
            v-else
            class="w-5 h-5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M13 7l5 5m0 0l-5 5m5-5H6"
            />
          </svg>
        </button>
      </div>
    </div>

    <!-- Rozšířený input modal -->
    <Transition name="modal">
      <div
        v-if="isExpanded && !isLoading"
        class="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-end sm:items-center justify-center p-0 sm:p-4"
        :style="modalPositionStyle"
        @click="handleBackdropClick"
      >
        <div
          ref="modalContent"
          class="bg-white rounded-t-2xl sm:rounded-2xl shadow-2xl w-full sm:max-w-4xl max-h-[70vh] sm:max-h-[80vh] flex flex-col"
          @click.stop
        >
          <!-- Modal header - kompaktní -->
          <div class="flex items-center justify-between p-3 border-b border-gray-200">
            <!-- Přepínač délky -->
            <div class="flex gap-1 overflow-x-auto">
              <button
                v-for="opt in responseOptions"
                :key="opt.value"
                :class="[
                  'px-2 py-1 rounded border transition-all text-xs font-medium whitespace-nowrap',
                  props.responseLength === opt.value
                    ? 'bg-red-600 text-white border-red-600'
                    : 'bg-white text-gray-600 border-gray-200 hover:border-gray-300',
                ]"
                @click="$emit('setResponseLength', opt.value)"
                :title="opt.title"
              >
                {{ opt.label }}
              </button>
            </div>

            <button
              @click="collapseInput"
              class="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-full transition-all flex-shrink-0 ml-2"
              title="Zavřít"
            >
              <svg
                class="w-5 h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>

          <!-- Modal body -->
          <div class="flex-1 p-4 overflow-y-auto">
            <textarea
              v-model="localValue"
              ref="expandedTextarea"
              @keydown.ctrl.enter.prevent="submit"
              @keydown.meta.enter.prevent="submit"
              class="w-full h-full min-h-[200px] resize-none border-0 focus:outline-none text-base leading-relaxed"
              placeholder="Popište svou situaci nebo otázku podrobněji...

• Jaký typ vytápění aktuálně používáte?
• Kolik máte vytápěnou plochu?
• Máte nějaké specifické požadavky?

Tip: Použijte Ctrl+Enter nebo Cmd+Enter pro odeslání"
              :disabled="disabled"
            ></textarea>
          </div>

          <!-- Modal footer -->
          <div class="p-4 border-t border-gray-200 bg-gray-50 rounded-b-2xl">
            <div class="flex items-center justify-between">
              <div class="text-sm text-gray-500">
                <span class="hidden sm:inline"
                  >Ctrl+Enter nebo Cmd+Enter pro odeslání</span
                >
                <span class="sm:hidden"
                  >{{ (localValue || "").length }} znaků</span
                >
              </div>

              <div class="flex gap-3">
                <button
                  @click="collapseInput"
                  class="px-4 py-2 text-gray-600 hover:text-gray-800 transition-colors"
                >
                  Zrušit
                </button>
                <button
                  @click="submit"
                  :disabled="!(localValue || '').trim() || disabled"
                  class="px-6 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 disabled:opacity-50 disabled:cursor-not-allowed transition-all flex items-center gap-2"
                >
                  <span>Odeslat</span>
                  <svg
                    class="w-4 h-4"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M13 7l5 5m0 0l-5 5m5-5H6"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Transition>
  </div>
</template>

<script setup>
import { ref, watch, nextTick, computed, onMounted, onUnmounted } from "vue";
import { getAuthToken } from "@/composables/useAuth.js";

const props = defineProps({
  modelValue: {
    type: String,
    default: "",
  },
  disabled: Boolean,
  isLoading: {
    type: Boolean,
    default: false,
  },
  suggestions: {
    type: Array,
    default: () => [],
  },
  responseLength: {
    type: String,
    default: "normal",
  },
  sessionId: {
    type: String,
    default: "",
  },
});

const emit = defineEmits([
  "send",
  "update:modelValue",
  "suggestion",
  "consultation",
  "setResponseLength",
  "cancel",
]);

// File upload constants
const MAX_FILE_SIZE = 15 * 1024 * 1024; // 15MB
const MAX_FILES = 10;
const ALLOWED_TYPES = [
  'image/jpeg', 'image/png', 'image/gif', 'image/webp',
  'application/pdf',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/msword',
  'text/markdown', 'text/plain',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-excel', 'text/csv',
  'application/zip', 'application/x-zip-compressed'
];

const localValue = ref(props.modelValue || "");
const isExpanded = ref(false);
const compactInput = ref(null);
const expandedTextarea = ref(null);
const modalContent = ref(null);

// iOS keyboard handling
const keyboardHeight = ref(0);
const modalPositionStyle = computed(() => {
  if (keyboardHeight.value > 0) {
    return { paddingBottom: `${keyboardHeight.value}px` };
  }
  return {};
});

// File upload refs
const fileInput = ref(null);
const pendingFiles = ref([]);
const isDragging = ref(false);
const isUploading = ref(false);

// Styly odpovědí
const responseOptions = [
  {
    value: "concise",
    icon: '<div class="flex flex-col gap-[0.5px]"><div class="w-2 h-[1px] bg-current"></div></div>',
    title: "Stručná - 3-5 vět, na bod",
    label: "Stručná",
    shortLabel: "—",
  },
  {
    value: "normal",
    icon: '<div class="flex flex-col gap-[0.5px]"><div class="w-2 h-[1px] bg-current"></div><div class="w-2 h-[1px] bg-current"></div></div>',
    title: "Běžná - přátelský styl, emoji, na TY",
    label: "Běžná",
    shortLabel: "≡",
  },
  {
    value: "detailed",
    icon: '<div class="flex flex-col gap-[0.5px]"><div class="w-2 h-[1px] bg-current"></div><div class="w-2 h-[1px] bg-current"></div><div class="w-2 h-[1px] bg-current"></div></div>',
    title: "Podrobná - tabulky, detaily, kompletní info",
    label: "Podrobná",
    shortLabel: "☰",
  },
  {
    value: "formal",
    icon: '<div class="text-[8px] font-bold">VY</div>',
    title: "Formální - vykat, minimum emoji, pro nabídky",
    label: "Formální",
    shortLabel: "VY",
  },
];

watch(
  () => props.modelValue,
  (val) => {
    localValue.value = val || "";
  }
);

watch(localValue, (val) => {
  emit("update:modelValue", val || "");
});

// Auto-expand při delším textu
watch(localValue, (val) => {
  if (val && val.length > 100 && !isExpanded.value) {
    // Automaticky rozbal při delším textu
    // expandInput();
  }
});

function handleInputFocus() {
  // Při kliknutí na input by se mohlo automaticky rozbalit
  // expandInput();
}

async function expandInput() {
  // Neotevírat modal během loading
  if (props.isLoading) return;

  isExpanded.value = true;
  await nextTick();

  // Focus na textarea a nastav cursor na konec
  if (expandedTextarea.value) {
    expandedTextarea.value.focus();
    const length = localValue.value.length;
    expandedTextarea.value.setSelectionRange(length, length);
  }
}

async function collapseInput() {
  isExpanded.value = false;
  await nextTick();

  // Vrať focus na kompaktní input
  if (compactInput.value) {
    compactInput.value.focus();
  }
}

function handleBackdropClick(event) {
  // Zavři modal při kliknutí mimo obsah
  if (event.target === event.currentTarget) {
    collapseInput();
  }
}

function submit() {
  const trimmedValue = (localValue.value || "").trim();
  const uploadedFiles = pendingFiles.value.filter(f => f.uploaded && f.uploadedData);

  // Kontrola loading stavu - povolit odeslání pokud je text NEBO nahrané soubory
  const hasContent = trimmedValue || uploadedFiles.length > 0;

  if (!hasContent || props.disabled || props.isLoading || isUploading.value) {
    return;
  }

  // Připrav data příloh pro odeslání
  const attachments = uploadedFiles.map(f => ({
    id: f.uploadedData.id,
    fileName: f.uploadedData.fileName,
    fileType: f.uploadedData.fileType,
    contentType: f.uploadedData.contentType,
    driveUrl: f.uploadedData.driveUrl,
    extractedText: f.uploadedData.extractedText,
    base64Data: f.uploadedData.base64Data, // Pro obrázky
  }));

  // Emit s přílohy
  emit("send", trimmedValue, attachments);

  // Vyčisti stav
  localValue.value = "";
  pendingFiles.value = [];

  // Zavři modal po odeslání
  if (isExpanded.value) {
    collapseInput();
  }
}

// ============================================
// FILE UPLOAD FUNCTIONS
// ============================================

function triggerFileInput() {
  if (fileInput.value) {
    fileInput.value.click();
  }
}

function handleFileSelect(event) {
  const files = event.target.files;
  if (files) {
    addFiles(Array.from(files));
  }
  // Reset input pro možnost vybrat stejný soubor znovu
  if (fileInput.value) {
    fileInput.value.value = '';
  }
}

function handleDrop(event) {
  isDragging.value = false;
  const files = event.dataTransfer?.files;
  if (files) {
    addFiles(Array.from(files));
  }
}

function addFiles(files) {
  // Validace počtu souborů
  const currentCount = pendingFiles.value.length;
  const newCount = files.length;

  if (currentCount + newCount > MAX_FILES) {
    alert(`Maximální počet souborů je ${MAX_FILES}. Aktuálně máte ${currentCount} souborů.`);
    return;
  }

  for (const file of files) {
    // Validace typu
    if (!ALLOWED_TYPES.includes(file.type)) {
      console.warn(`Nepodporovaný typ souboru: ${file.name} (${file.type})`);
      alert(`Nepodporovaný typ souboru: ${file.name}`);
      continue;
    }

    // Validace velikosti
    if (file.size > MAX_FILE_SIZE) {
      alert(`Soubor ${file.name} je příliš velký (max ${MAX_FILE_SIZE / 1024 / 1024}MB)`);
      continue;
    }

    // Přidej do seznamu
    pendingFiles.value.push({
      file,
      name: file.name,
      size: file.size,
      type: file.type,
      uploading: false,
      uploaded: false,
      uploadedData: null,
      error: null
    });
  }

  // Automaticky začni upload
  if (pendingFiles.value.some(f => !f.uploaded && !f.uploading)) {
    uploadFiles();
  }
}

function removeFile(index) {
  pendingFiles.value.splice(index, 1);
}

async function uploadFiles() {
  if (!props.sessionId) {
    console.error('❌ SessionId není k dispozici pro upload');
    alert('Chyba: SessionId není k dispozici. Zkuste obnovit stránku.');
    return;
  }

  isUploading.value = true;

  // Najdi soubory k uploadu
  const filesToUpload = pendingFiles.value.filter(f => !f.uploaded && !f.uploading);

  if (filesToUpload.length === 0) {
    isUploading.value = false;
    return;
  }

  // Označ jako uploading
  filesToUpload.forEach(f => f.uploading = true);

  try {
    // Připrav data pro API
    const filesData = await Promise.all(filesToUpload.map(async (pf) => {
      const buffer = await pf.file.arrayBuffer();
      const base64 = btoa(
        new Uint8Array(buffer).reduce((data, byte) => data + String.fromCharCode(byte), '')
      );
      return {
        name: pf.name,
        type: pf.type,
        data: base64
      };
    }));

    // Získej auth token
    const token = getAuthToken() || 'dev-token-bypass';

    // Volej upload API
    const response = await fetch('/api/chat/upload', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({
        sessionId: props.sessionId,
        files: filesData
      })
    });

    const result = await response.json();

    if (result.success && result.files) {
      // Aktualizuj stav souborů
      result.files.forEach((uploadedFile, idx) => {
        const pendingFile = filesToUpload[idx];
        if (pendingFile) {
          pendingFile.uploading = false;
          if (uploadedFile.success) {
            pendingFile.uploaded = true;
            pendingFile.uploadedData = uploadedFile;
          } else {
            pendingFile.error = uploadedFile.error;
          }
        }
      });
    } else {
      // Chyba
      filesToUpload.forEach(f => {
        f.uploading = false;
        f.error = result.error || 'Upload selhal';
      });
    }
  } catch (error) {
    console.error('Upload error:', error);
    filesToUpload.forEach(f => {
      f.uploading = false;
      f.error = error.message;
    });
  } finally {
    isUploading.value = false;
  }
}

function getFileIcon(mimeType) {
  if (mimeType?.startsWith('image/')) return '🖼️';
  if (mimeType?.includes('pdf')) return '📄';
  if (mimeType?.includes('word') || mimeType?.includes('document')) return '📝';
  if (mimeType?.includes('sheet') || mimeType?.includes('excel') || mimeType?.includes('csv')) return '📊';
  if (mimeType?.includes('zip')) return '📦';
  if (mimeType?.includes('markdown') || mimeType?.includes('text')) return '📃';
  return '📎';
}

function formatFileSize(bytes) {
  if (bytes < 1024) return bytes + ' B';
  if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
  return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
}

// ============================================

function handleSuggestion(suggestion) {
  // Neklikat na suggestions během loading
  if (props.isLoading) return;
  emit("suggestion", suggestion);
}

// Klávesové zkratky
function handleKeydown(event) {
  if (event.key === "Escape" && isExpanded.value) {
    event.preventDefault();
    collapseInput();
  }
}

// iOS keyboard handling via visualViewport API
function handleViewportResize() {
  if (window.visualViewport) {
    const viewportHeight = window.visualViewport.height;
    const windowHeight = window.innerHeight;
    keyboardHeight.value = Math.max(0, windowHeight - viewportHeight);
  }
}

onMounted(() => {
  document.addEventListener("keydown", handleKeydown);
  if (window.visualViewport) {
    window.visualViewport.addEventListener("resize", handleViewportResize);
  }
});

onUnmounted(() => {
  document.removeEventListener("keydown", handleKeydown);
  if (window.visualViewport) {
    window.visualViewport.removeEventListener("resize", handleViewportResize);
  }
});
</script>

<style scoped>
/* Skryj scrollbar ale zachovej scrollování */
.scrollbar-hide {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.scrollbar-hide::-webkit-scrollbar {
  display: none;
}

/* Modal animace */
.modal-enter-active,
.modal-leave-active {
  transition: all 0.3s ease;
}

.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}

.modal-enter-from .bg-white,
.modal-leave-to .bg-white {
  transform: scale(0.9) translateY(20px);
}

.modal-enter-active .bg-white,
.modal-leave-active .bg-white {
  transition: transform 0.3s ease;
}

/* Placeholder styling pro textarea */
textarea::placeholder {
  color: #9ca3af;
  line-height: 1.6;
}

/* Přidat animaci pro loading indikátor */
.slide-enter-active,
.slide-leave-active {
  transition: all 0.3s ease;
}

.slide-enter-from {
  transform: translateY(10px);
  opacity: 0;
}

.slide-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}

/* Bounce animace pro tečky */
@keyframes bounce {
  0%,
  60%,
  100% {
    transform: translateY(0);
  }
  30% {
    transform: translateY(-10px);
  }
}

/* Responsive úpravy */
@media (max-width: 640px) {
  .modal-content {
    margin: 1rem;
    max-height: 85vh;
  }
}
</style>
